import { Smartphone } from 'lucide-react'

import { DiscordIcon } from '@/components/icons/BrandIcons'
import { Button } from '@/components/ui/button'
import { ANDROID_STATUS, DISCORD_INVITE_URL } from '@/lib/config/links'
import { ctaClicked } from '@/lib/analytics'

/**
 * The two things a visitor can do while sign-ups are closed, besides joining
 * the waitlist: talk to us now, and know the app is coming.
 *
 * Android renders as static text until `ANDROID_STATUS.url` is set. A button
 * that lands on a Play Store 404 is worse than no button — it reads as a
 * broken product rather than an unreleased one.
 */
export function PreLaunchActions() {
  return (
    <div className="flex flex-col items-center gap-3 sm:flex-row">
      <Button asChild variant="outline" size="lg">
        <a
          href={DISCORD_INVITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => ctaClicked('discord', 'prelaunch_actions', DISCORD_INVITE_URL)}
        >
          <DiscordIcon className="size-4" aria-hidden />
          Join our Discord
        </a>
      </Button>

      {ANDROID_STATUS.available && ANDROID_STATUS.url ? (
        <Button asChild variant="ghost" size="lg">
          <a href={ANDROID_STATUS.url} target="_blank" rel="noopener noreferrer">
            <Smartphone className="size-4" aria-hidden />
            Get it on Android
          </a>
        </Button>
      ) : (
        <span className="font-display inline-flex items-center gap-2 px-3 py-1.5 text-sm text-fg-muted">
          <Smartphone className="size-4" aria-hidden />
          Android app coming soon
        </span>
      )}
    </div>
  )
}
